// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2l43T","label":"styles_label__1t7Ic"};